/**
 * Word list helpers: multilevel outline numbering (1., 1.1, 1.1.1) requires numbering
 * at every list level; otherwise Word falls back to bullets on sub-levels.
 */

/* global Word */

/**
 * Calls `List.setLevelNumbering` for levels 0–8. Word's enum value **`"Arabic"`** means
 * **Western decimal digits (1, 2, 3)** — standard English-style numbering; the name is
 * historical and does not refer to Arabic-script numerals (١٢٣).
 */
export function applyStandardOutlineNumbering(
  list: Word.List,
  numbering: 'Arabic' | 'LowerLetter' | 'UpperLetter' | 'LowerRoman' | 'UpperRoman' = 'Arabic'
): void {
  for (let lvl = 0; lvl <= 8; lvl++) {
    list.setLevelNumbering(lvl, numbering);
  }
}

/** Apply the same bullet style to levels 0–8 (optional multilevel bullet lists). */
export function applyBulletAllLevels(
  list: Word.List,
  bullet: 'Solid' | 'Hollow' | 'Square' = 'Solid'
): void {
  for (let lvl = 0; lvl <= 8; lvl++) {
    list.setLevelBullet(lvl, bullet);
  }
}
